import React, {Component} from 'react';
import DateUtils from "../../../../../../monitoring/src/Utils/DateUtils";

export const ExpiringPermitDetailsActivityFeedItemDescription = props => {

    const formatDate = (date) => {
        return DateUtils.FormatDate(date, "MMM d, yyyy");
    }
    
    const getExpirationMessage = () => {
        const expirationDate = props.CustomEventData?.permit?.expirationDate;
        if (!expirationDate) {
            return null;
        }

        return ` It will expire on ${formatDate(expirationDate)}`;
    }

    const { CustomEventData } = props;

    return <p>
        Permit {CustomEventData?.permit?.permitNumber} from {CustomEventData?.permitOrg} for {CustomEventData?.conservationActions} must be renewed by {formatDate(CustomEventData?.permit?.renewalDate)}.
    </p>;
}


